function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "icon_rebook_white");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "icon_rebook_white",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M27.233727,13.866861 C27.233727,18.47843 24.902878,22.546968 21.352304,24.944653 C19.213606,26.389946 16.640486,27.233727 13.866861,27.233727 C6.4816713,27.233727 0.5,21.252054 0.5,13.866861 C0.5,6.4816713 6.4816713,0.5 13.866861,0.5 C17.484268,0.5 20.75915,1.9369383 23.165186,4.2677851",
  id: "Stroke-1",
  stroke: "#FFFFFF"
}), /*#__PURE__*/React.createElement("polyline", {
  id: "Stroke-2",
  stroke: "#FFFFFF",
  points: "24.7024459 1.3354492 24.6272579 5.9887876 20.0574609 5.913599"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.73805345,17.041504 C9.107169,17.041504 9.4222291,17.1720061 9.6832333,17.4330103 C9.9442375,17.6940145 10.0747395,18.0090745 10.0747397,18.3781902 C10.0747395,18.7473058 9.9442375,19.0623659 9.6832333,19.3233701 C9.4222291,19.5843743 9.107169,19.7148763 8.73805345,19.7148765 C8.36893768,19.7148763 8.05387772,19.5843743 7.79287351,19.3233701 C7.5318693,19.0623659 7.4013672,18.7473058 7.4013672,18.3781902 C7.4013672,18.0090745 7.5318693,17.6940145 7.79287351,17.4330103 C8.05387772,17.1720061 8.36893768,17.041504 8.73805345,17.041504 Z",
  id: "Stroke-3",
  stroke: "#FFFFFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.5066082,17.041504 C19.8757238,17.041504 20.1907839,17.1720061 20.4517881,17.4330103 C20.7127923,17.6940145 20.8432943,18.0090745 20.8432945,18.3781902 C20.8432943,18.7473058 20.7127923,19.0623659 20.4517881,19.3233701 C20.1907839,19.5843743 19.8757238,19.7148763 19.5066082,19.7148765 C19.1374925,19.7148763 18.8224325,19.5843743 18.5614283,19.3233701 C18.3004241,19.0623659 18.169922,18.7473058 18.169922,18.3781902 C18.169922,18.0090745 18.3004241,17.6940145 18.5614283,17.4330103 C18.8224325,17.1720061 19.1374925,17.041504 19.5066082,17.041504 Z",
  id: "Stroke-4",
  stroke: "#FFFFFF"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Stroke-5",
  stroke: "#FFFFFF",
  points: "6.2060547 7.4589844 17.325613 7.4589844 17.325613 15.9135247 6.2060547 15.9135247"
}), /*#__PURE__*/React.createElement("polyline", {
  id: "Stroke-6",
  stroke: "#FFFFFF",
  points: "21.0183491 18.3780613 22.2213631 18.3780613 22.2213631 14.1090203 19.4143221 10.5083213 18.6206661 10.5083213"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.2203856,18.37793 L9.8076172,18.37793",
  id: "Stroke-7",
  stroke: "#FFFFFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.40946677,18.37793 L5.7636719,18.37793",
  id: "Stroke-8",
  stroke: "#FFFFFF"
}));

var SvgIconRebookWhite = function SvgIconRebookWhite(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconRebookWhite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_rebook_white.04019fca.svg";
export { ForwardRef as ReactComponent };